export default __webpack_public_path__ + "static/media/twitter.fcba4a8e.svg";